<div cdkDropList (cdkDropListDropped)="drop($event)" class="cdkDropList">
    <div *ngIf="useDefault">
        <div *ngFor="let c of defaultColumns" cdkDrag class="settings-row" [cdkDragDisabled]="true">
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <i class="fa fa-bars"></i>
            <input [ngModel]="c.name" [disabled]="true">
        </div>
    </div>
    <div *ngIf="!useDefault">
        <div *ngFor="let c of selectedColumns" cdkDrag class="settings-row">
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <i class="fa fa-bars"></i>
            <input [ngModel]="c.name" [disabled]="true">
        </div>
    </div>

</div>
<div class="default-checkbox-container">
    <mat-checkbox class="checkbox" id="default-order" (change)="defaultOrder($event)">{{ 'dashboard:Use default column
        order' | i18next }}</mat-checkbox>
    <!-- <input type="checkbox" id="default-order" name="default-order" (click)="defaultOrder($event)" />
    <label for="default-order">Use default column order</label> -->
</div>